<div class="tw-grid tw-place-content-center">
  <div class="tw-relative tw-h-[80px] tw-w-[80px]">
    <div
      class="tw-absolute tw-h-[80px] tw-w-[80px] tw-z-10 tw-grid tw-place-content-center tw-font-extrabold tw-text-xl"
    >
      {{ percentageValue || 0 }}%
    </div>
    <div class="progress_box">
      <mat-progress-spinner
        class="graph graph_box"
        [ngClass]="colorScheme === 'qualification' ? qualification : nps"
        [strokeWidth]="strokeWidth"
        [diameter]="diameter"
        [mode]="'determinate'"
        [value]="fillValue"
      >
      </mat-progress-spinner>

      <mat-progress-spinner
        class="graph total_graph"
        [ngClass]="doubleFill ? 'detractor' : 'default'"
        [strokeWidth]="strokeWidth"
        [diameter]="diameter"
        [mode]="'determinate'"
        [value]="100"
      >
      </mat-progress-spinner>
    </div>
  </div>
</div>
